import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Remplacer useHistory par useNavigate
import Card from 'components/Card/Card';
import '../../styles/styles.css';
import { Article } from '../../data/types';
import axios from 'axios';

const API_URL = 'https://ahuncycle-backend.vercel.app';
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

const PageRecherche: React.FC = () => {
  const [listeArticles, setListeArticles] = useState<Article[]>([]);
  const navigate = useNavigate(); // Utilisation de useNavigate
  const location = useLocation();

  useEffect(() => {
    const getArticles = async () => {
      const query = new URLSearchParams(location.search).get('q');
      let response: { data: Article[] } = { data: [] };
      try {
        if (query) {
          response = await axiosInstance.get(`/api/articles/recherche/${encodeURIComponent(query)}`);
        } else {
          response = await axiosInstance.get('/api/articles');
        }
        setListeArticles(response.data);
      } catch (error) {
        console.log('Erreur : ' + error);
      }
    };
    getArticles();
  }, [location.search]); // Déclenche le hook quand l'URL change

  const handleSearch = (query: string) => {
    navigate(`/recherche?q=${encodeURIComponent(query)}`); // Utilisation de navigate pour modifier l'URL
  };

  return (
    <div className="stretch bgColor">
      <div className="container py-6 lg:py-8 ">
        <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl">Articles</h2>
        <span className="block text-neutral-300">{listeArticles.length} articles</span>

        <div className="mt-6 flex flex-col sm:items-center sm:justify-between sm:flex-row">
          <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
          <div className="flex justify-end"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 md:gap-x-8 md:gap-y-10 mt-8 lg:mt-10">
          {listeArticles.map((post: Article) => (
            <Card post={post} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PageRecherche;
